import { FC, useState } from 'react'
import { Button, useRecordContext, useRefresh, useNotify } from 'react-admin'
import SyncIcon from '@mui/icons-material/Sync'
import { CircularProgress } from '@mui/material'
import { postJson, getUrl } from '../providers/data'

interface SyncResult {
  tools_created: number
  tools_updated: number
  tools_disabled: number
}

interface SyncButtonProps {
  resource: string
}

export const SyncButton: FC<SyncButtonProps> = ({ resource }) => {
  const record = useRecordContext<{ id: string }>()
  const refresh = useRefresh()
  const notify = useNotify()
  const [loading, setLoading] = useState(false)

  const handleSync = async () => {
    if (!record?.id) return
    setLoading(true)
    try {
      const result = await postJson<SyncResult>(`${getUrl()}/${resource}/${record.id}/sync`)
      notify(
        `Sync voltooid: ${result.tools_created} aangemaakt, ${result.tools_updated} bijgewerkt, ${result.tools_disabled} uitgeschakeld`,
        { type: 'success' }
      )
      refresh()
    } catch {
      notify('data.syncFailed', { type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button label="data.syncTools" onClick={() => void handleSync()} disabled={loading}>
      {loading ? <CircularProgress size={18} /> : <SyncIcon />}
    </Button>
  )
}
